var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex items-center shrink-0 gap-2 py-2 px-4 rounded-full border-2",class:{
        'border-[#924AFF]': _vm.isActive,
        'border-transparent': !_vm.isActive
    },staticStyle:{"background":"hsla(0, 0%, 100%, 0.1)","cursor":"pointer"},on:{"click":function($event){return _vm.$emit('click', _vm.value)}}},[_c('img',{staticClass:"mx-auto p-0 m-0",staticStyle:{"width":"2rem"},attrs:{"src":_vm.icon,"alt":_vm.label}}),_c('span',{staticClass:"text-[13px] whitespace-nowrap",class:{ 'text-white': _vm.isActive }},[_vm._v(" "+_vm._s(_vm.label)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }